import state from './Sale/states'
import mutations from './Sale/mutations'
import actions from './Sale/actions'
import getters from './Sale/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
